module.exports = __webpack_public_path__ + "img/empty2.d53711b5.png";